import { render, staticRenderFns } from "./CommsList.vue?vue&type=template&id=048a3931&scoped=true&"
import script from "./CommsList.vue?vue&type=script&lang=js&"
export * from "./CommsList.vue?vue&type=script&lang=js&"
import style0 from "./CommsList.vue?vue&type=style&index=0&id=048a3931&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a3931",
  null
  
)

export default component.exports